import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL } from "../../app.constants";

@Injectable()
export class AdService {

  constructor(private http: HttpClient) {

  }

  getAds(): any {
    return this.http.get(`${BASE_URL}/poster`);
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/ad.service.ts